<template>
  <div>
    <BlockHeader name="Server settings / SMTP" />
    <div class="row">
      <div class="col-lg-6 col-sm-12 col-xs-12">
        <Input
          v-model="settingsLocal.email_smtp"
          form-group-id="Hostname"
          placeholder="Server Host"
        />
      </div>
      <div class="col-lg-6 col-sm-12 col-xs-12">
        <Input
          v-model="settingsLocal.email_port"
          form-group-id="Port"
          placeholder="Port"
        />
      </div>
      <div class="col-lg-6 col-sm-12 col-xs-12">
        <Input
          v-model="settingsLocal.email_username"
          form-group-id="Username"
          placeholder="Username"
        />
      </div>
      <div class="col-lg-6 col-sm-12 col-xs-12">
        <Input
          v-model="settingsLocal.email_password"
          form-group-id="Password"
          placeholder="Password"
          type="password"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Input from '../../../../../common/input/index';
import BlockHeader from '../../../../../common/block-header';

export default {
  name: 'Email',
  components: { Input, BlockHeader },
  props: {
    settings: {
      type: Object,
      default: () => {}
    }
  },
  data: function() {
    return {};
  },
  computed: {
    settingsLocal: {
      get: function() {
        return this.settings;
      },
      set: function(value) {
        this.$emit('settings', value);
      }
    }
  }
};
</script>
